module.exports = noop;
module.exports.HttpsAgent = noop;

// Noop function for browser since native api's don't use agents.
function noop () {}



/*****************
 ** WEBPACK FOOTER
 ** ./~/agentkeepalive/browser.js
 ** module id = 840
 ** module chunks = 0
 **/